import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, tap } from "rxjs";
import { liveLessonAuthActions } from "@pcp/auth";
import { Router } from "@angular/router";


@Injectable()
export class AuthEffectsEffects {

    private readonly actions$ = inject(Actions);
    private readonly snackbar = inject(MatSnackBar);
    private readonly router = inject(Router);

    readonly redirectAfterLogin$ = createEffect(() => this.actions$.pipe(
        ofType(
            liveLessonAuthActions.userLoginSuccess,
            liveLessonAuthActions.tokenRestoreSuccess,
        ),
        switchMap(() => this.router.navigate(['/room'])),
    ), { dispatch: false });

}
